// 系统环境配置
export const APP_ENV_CONFIG = {
    // 正式版
    PROD: {
        BASE_URL: 'https://pro.kapaisy.com/my/',
        requestTimeout: 30000,
        ORIGIN: 'origin/', // 原图
        COMPRESS: 'compress/', // 压缩图
        appId: 6,
        versionName: '19.0.',
        onLineDate: '2021-05-20', // 系统上线时间
        BASEURL: 'https://res.kapaisy.com/',
        imageUrl: 'https://res.kapaisy.com/config/2.0.0/assets/',
        shareUrl: 'https://h5.kapaisy.com/albumshare/index.html',
        photoUrl: 'https://res.kapaisy.com/album',
        default_screen_url: 'https://res.kapaisy.com/config/default/RmD3zf721675998782000.jpg',
        default_watermark_bg: 'https://sfc.kapaisy.com/config/default/defalut_watermark_bg.jpg',
        env: 'prod/album'
    },
    // 预发布
    PRE: {
        BASE_URL: 'https://pro.kapaisy.com/pre/',
        requestTimeout: 30000,
        ORIGIN: 'origin/', // 原图
        COMPRESS: 'compress/', // 压缩图
        appId: 6,
        versionName: '11.1',
        onLineDate: '2021-05-20', // 系统上线时间
        BASEURL: 'https://res.kapaisy.com/',
        imageUrl: 'https://res.kapaisy.com/config/2.0.0/assets/',
        shareUrl: 'https://h5.kapaisy.com/albumshare/index.html',
        photoUrl: 'https://res.kapaisy.com/album',
        default_screen_url: 'https://res.kapaisy.com/config/default/RmD3zf721675998782000.jpg',
        default_watermark_bg: 'https://sfc.kapaisy.com/config/default/defalut_watermark_bg.jpg',
        env: 'prod/album'
    },
    // 开发版
    DEV: {
        BASE_URL: 'http://192.168.1.85:17000/my/',
        requestTimeout: 30000,
        ORIGIN: 'origin/', // 原图
        COMPRESS: 'compress/', // 压缩图
        appId: 6,
        versionName: '7.2',
        onLineDate: '2021-05-20', // 系统上线时间
        BASEURL: 'https://res.kapaisy.com/',
        imageUrl: 'https://res.kapaisy.com/config/2.0.0/assets/',
        shareUrl: 'http://192.168.1.42:5173/',
        photoUrl: 'https://res.kapaisy.com/album',
        default_screen_url: 'https://res.kapaisy.com/config/default/RmD3zf721675998782000.jpg',
        default_watermark_bg: 'https://sfc.kapaisy.com/config/default/defalut_watermark_bg.jpg',
        env: 'dev/album'
    },
    // 体验版
    TEST: {
        BASE_URL: 'https://pro.kapaisy.com/test/',
        requestTimeout: 30000,
        ORIGIN: 'origin/', // 原图
        COMPRESS: 'compress/', // 压缩图
        appId: 6,
        versionName: '7.2',
        onLineDate: '2021-05-20', // 系统上线时间
        BASEURL: 'https://res.kapaisy.com/',
        imageUrl: 'https://res.kapaisy.com/config/2.0.0/assets/',
        shareUrl: 'https://pro.kapaisy.com/test/my_utime/res/albumShare/index.html',
        photoUrl: 'https://res.kapaisy.com/test/album',
        default_screen_url: 'https://res.kapaisy.com/config/default/RmD3zf721675998782000.jpg',
        default_watermark_bg: 'https://sfc.kapaisy.com/config/default/defalut_watermark_bg.jpg',
        env: 'test/album'
    }
}

export default {
    EVN: APP_ENV_CONFIG.PROD
}